import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "react-reveal/Fade";

import { ThemeContext } from "../../contexts/ThemeContext";

import eduImgWhite from "../../assets/svg/education/eduImgWhite.svg";
import eduImgBlack from "../../assets/svg/education/eduImgBlack.svg";
import "./Education.css";

function EducationCard({ id, institution, course, startYear, endYear, grade }) {
  const { theme } = useContext(ThemeContext);

  const useStyles = makeStyles((t) => ({
    educationCard: {
      backgroundColor: theme.primary30,
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: theme.primary50,
        transform: "translateY(-5px)",
        boxShadow: `0 10px 20px ${theme.primary30}`,
      },
    },
  }));

  const classes = useStyles();

  return (
    <Fade bottom>
      <div key={id} className={`education-card ${classes.educationCard}`}>
        <div className="educard-img" style={{ backgroundColor: theme.primary }}>
          <img
            draggable={false}
            src={theme.type === "light" ? eduImgBlack : eduImgWhite}
            alt=""
          />
        </div>
        <div className="education-details">
          <h6 style={{ color: theme.primary }}>
            {startYear} - {endYear}
          </h6>
          <h4 style={{ color: theme.tertiary }}>{course}</h4>
          <h5 style={{ color: theme.tertiary80 }}>{institution}</h5>
          {grade && (
            <p
              style={{
                color: theme.primary,
                fontWeight: "600",
                fontSize: "0.9rem",
                marginTop: "0.5rem",
                fontFamily: "var(--primaryFont)",
              }}
            >
              {grade}
            </p>
          )}
        </div>
      </div>
    </Fade>
  );
}

export default EducationCard;
